import TariffReferralSettings from './TariffReferralSettings';

export default TariffReferralSettings;
